const referralLinks = {
    colsOrder: ['link', 'executor', 'count', 'status'],
    cols: {
        link: {
            content: 'Ссылка',
            width: 22,
        },
        executor: {
            content: 'Исполнитель',
            width: 50,
            isAdminMain: true,
        },
        count: {
            content: 'Участники',
            width: 14,
        },
        status: {
            content: 'Статус',
            width: 14,
        },
    },
    adminIndex: 0,
    deletesCols: [],
    url: 'referralLink',
    emptyInfo: {
        title: 'Ссылок пока нет',
        description: 'Они будут отображаться здесь',
    },
} as const;

export default referralLinks;
